import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function HoverImage(props) {
    const [active, setActive] = useState(0); // 0: Input, 1: Mask, 2: Dual Results

    const containerStyle = {
        position: 'relative',
        width: '100%',
        cursor: 'pointer',
        overflow: 'hidden',
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
        paddingBottom: active === 2 ? '0' : '100%' // Giữ khung vuông khi xem đơn lẻ
    };

    const singleImgStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    };

    return (
        <Box 
            style={containerStyle}
            onMouseEnter={() => { if(active !== 2) setActive(1); }}
            onMouseLeave={() => { if(active !== 2) setActive(0); }}
            onClick={() => setActive(active === 2 ? 0 : 2)}
        >
            {/* 1. Trạng thái hiển thị Input gốc */}
            {active === 0 && (
                <img src={props.srcInput} style={singleImgStyle} alt="Input object" />
            )}

            {/* 2. Trạng thái Hover hiện Mask phân đoạn */}
            {active === 1 && (
                <img src={props.srcMask} style={singleImgStyle} alt="Object Silhouette Mask" />
            )}

            {/* 3. Trạng thái Click: Hiện song song 2 kết quả để so sánh */}
            {active === 2 && (
                <Box sx={{ display: 'flex', width: '100%', backgroundColor: '#fff' }}>
                    <Box sx={{ width: '50%', borderRight: '1px solid #eee', position: 'relative' }}>
                        <img src={props.srcVisualRAG} style={{ width: '100%', display: 'block' }} alt="Visual-RAG" />
                        <Typography variant="caption" sx={{ position: 'absolute', bottom: 4, left: 4, bgcolor: 'rgba(0,0,0,0.6)', color: '#fff', px: 1, borderRadius: 1 }}>
                            Visual-RAG
                        </Typography>
                    </Box>
                    <Box sx={{ width: '50%', position: 'relative' }}>
                        <img src={props.srcSemanticRAG} style={{ width: '100%', display: 'block' }} alt="Semantic-RAG" />
                        <Typography variant="caption" sx={{ position: 'absolute', bottom: 4, left: 4, bgcolor: 'rgba(0,0,0,0.6)', color: '#fff', px: 1, borderRadius: 1 }}>
                            Semantic-RAG
                        </Typography>
                    </Box>
                </Box>
            )}
        </Box>
    );
}

export default HoverImage;